module.exports = __webpack_public_path__ + "img/ZG81_02.32f21d28.jpg";